import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { pageTitle } from '../../helper';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Div from '../Div';
import Cta from '../Cta';
import EquipmentTable from '../EquipmentTable';
import { getEquipmentData } from '../../data/equipmentListData';

export default function EquipmentPage() {
  const { t, i18n } = useTranslation();
  const language = i18n.language === 'en' ? 'en' : 'cs';
  const equipmentListData = getEquipmentData(language);

  pageTitle(t('equipmentPage.pageTitle'));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const introParagraphs = t('equipmentPage.introParagraphs', { returnObjects: true });

  const equipmentSchema = useMemo(() => {
    const items = [];
    let position = 1;

    equipmentListData.forEach((category) => {
      category.items.forEach((item) => {
        const name = `${item.vyrobce} ${item.typ}`.trim();
        items.push({
          '@type': 'ListItem',
          position,
          item: {
            '@type': 'Product',
            name,
            description: item.popis,
            category: category.category,
            brand: {
              '@type': 'Brand',
              name: item.vyrobce,
            },
          },
        });
        position += 1;
      });
    });

    return {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: t('equipmentPage.schemaTitle'),
      itemListElement: items,
    };
  }, [equipmentListData, t]);

  return (
    <>
      <Helmet>
        <title>{t('equipmentPage.metaTitle')}</title>
        <link rel="icon" href="/stablerecords.ico" />
        <meta name="description" content={t('equipmentPage.metaDescription')} />
        <script type="application/ld+json">{JSON.stringify(equipmentSchema)}</script>
      </Helmet>

      <PageHeading
        title={t('equipmentPage.pageTitle')}
        bgSrc="/images/about_hero_bg.jpeg"
        pageLinkText={t('equipmentPage.pageLinkText')}
      />

      <Spacing lg="80" md="50" />
      <Div className="container">
        <SectionHeading
          title={t('equipmentPage.sectionTitle')}
          subtitle={t('equipmentPage.sectionSubtitle')}
          variant="cs-style1 text-center"
        />
        <Spacing lg="40" md="30" />
        {Array.isArray(introParagraphs) && introParagraphs.map((text, index) => (
          <p key={index} className="cs-m0 mb-3">
            {text}
          </p>
        ))}
      </Div>

      <Spacing lg="60" md="40" />
      <Div className="container">
        <EquipmentTable />
      </Div>

      <Spacing lg="80" md="50" />
      <Div className="container">
        <Cta
          title={t('equipmentPage.ctaTitle')}
          btnText={t('equipmentPage.ctaBtn')}
          btnLink="/kontakt"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  );
}
